$(document).ready(function () {
  // Elements to inject
  var mySVGsToInject = document.querySelectorAll('img.inject-me');
  // Do the injection
  SVGInjector(mySVGsToInject);
})



// WEBPACK FOOTER //
// ./src/assets/js/_svg-injector.js